import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand robust-cms p-100">
      <Container className="h-100">
        <Row className="h-100 align-items-center">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Custom CMS Development Services We Offer</h2>
            <p>
              Customizable and performant Content Management System (CMS) helps
              businesses meet growing modern enterprise needs. Our CMS
              development company offers full-scale CMS development, migration,
              and upgrade services for automated, high-quality content
              production to win over cross-channel digital visibility and
              performance targets.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Start with a Free Consultation
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Custom CMS Development</h4>
                  <p>
                    Develop bespoke CMS platforms using advanced tech stack,
                    including PHP, Python, and JavaScript technologies. Ensure
                    seamless integration with existing systems and get
                    customized features, user permissions, and robust content
                    management.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>CMS Integration & Migration</h4>
                  <p>
                    Modernize your digital infrastructure by integrating and
                    migrating to contemporary CMS platforms. Ensure smooth data
                    migration, improved performance, and enhanced functionality
                    without disrupting existing workflows.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Content & Data Migration</h4>
                  <p>
                    Expertly migrate content and data from legacy systems,
                    ensuring data integrity and minimal downtime. Implement
                    advanced data transformation techniques to future-proof
                    digital assets and streamline content management processes.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>API Development & Integration</h4>
                  <p>
                    Enhance CMS functionality with custom API development and
                    integration. Enable seamless communication between your CMS
                    and third-party applications with secure, scalable, and
                    efficient data exchange across platforms.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Performance Optimization</h4>
                  <p>
                    Optimize CMS performance with advanced techniques like
                    caching, load balancing, and code optimization. Ensure fast
                    page load times, high availability, and scalability to
                    handle peak traffic and provide an excellent user
                    experience.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Security & Maintenance</h4>
                  <p>
                    Implement robust security measures including SSL encryption,
                    regular security audits, and vulnerability assessments. Get
                    ongoing maintenance and support to ensure your CMS remains
                    secure, up-to-date, and performs optimally.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
